<div class="violation">
    <div [ngClass]="{ linkable: linkable }">
        {{ value | beautifyDisplayNumber }}
    </div>
    <div [class]="color"></div>
</div>
